import { clubList } from './lists/clubList';
import services from '@/app/shared/services';

const clubStore = {
  state: {
    overrideClub: false,
    overridingClubId: 0,
    homeClubDetails: null,
    additionalBookers: null,
  },

  getters: {
    getClub: (state, getters, rootState) => {
      if (state.overrideClub) {
        return clubList.find(club => club.clubId === state.overridingClubId) !== undefined
          ? clubList.find(club => club.clubId === state.overridingClubId)
          : clubList.find(club => club.clubId === 0);
      }
      return clubList.find(club => club.clubId === rootState.user.homeClubId) !== undefined
        ? clubList.find(club => club.clubId === rootState.user.homeClubId)
        : clubList.find(club => club.clubId === 0);
    },

    hasGolf: (state) => {
      const courses = state.homeClubDetails && state.homeClubDetails.Courses
        ? state.homeClubDetails.Courses
        : [];
      return courses.some(c => c.FacilityType === 0);
    },
    hasSpa: (state) => {
      const courses = state.homeClubDetails && state.homeClubDetails.Courses
        ? state.homeClubDetails.Courses
        : [];
      return courses.some(c => c.FacilityType === 1);
    },
    hasGym: (state) => {
      const courses = state.homeClubDetails && state.homeClubDetails.Courses
        ? state.homeClubDetails.Courses
        : [];
      return courses.some(c => c.FacilityType === 2);
    },
    miscId: (state) => {
      const courses = state.homeClubDetails && state.homeClubDetails.Courses
        ? state.homeClubDetails.Courses
        : [];
      const miscCourse = courses.find(c => c.FacilityType === 3);
      return miscCourse ? miscCourse.Id : null;
    },
    hasRestaurant: (state) => {
      const courses = state.homeClubDetails && state.homeClubDetails.Courses
        ? state.homeClubDetails.Courses
        : [];
      return courses.some(c => c.FacilityType === 4);
    },
    disableCheckout: (state) => {
      if (state.homeClubDetails === null) {
        return false;
      }

      const courses = state.homeClubDetails.Courses || [];
      const hasSpaCourse = courses.some(c => c.FacilityType === 1);
      const club = clubList.find(c => c.clubId === state.homeClubDetails.Id);

      return hasSpaCourse || (club && typeof club.disableCheckout !== 'undefined' ? club.disableCheckout : false);
    },
    disablePoints: (state) => {
      if (state.homeClubDetails === null) {
        return false;
      }

      const club = clubList.find(c => c.clubId === state.homeClubDetails.Id);

      return club && typeof club.disablePoints !== 'undefined' ? club.disablePoints : false;
    },
    disableLanding: (state) => {
      if (state.homeClubDetails === null) {
        return false;
      }

      const club = clubList.find(c => c.clubId === state.homeClubDetails.Id);

      return club && typeof club.disableLanding !== 'undefined' ? club.disableLanding : false;
    },
  },

  mutations: {
    setAdditionalBookers(state, value) {
      state.additionalBookers = value;
    },

    setClubDetails(state, value) {
      state.homeClubDetails = value;
    },

    setOverrideStyle(state, value) {
      if (typeof value === 'number') {
        const favicon = document.getElementById('favicon');
        favicon.href = `/img/icons/${value}.ico`;
      }

      state.overrideClub = value;
    },

    setOverridingClubId(state, value) {
      if (!(isNaN(value))) {
        state.overridingClubId = Number(value);
        state.overrideClub = true;
      } else {
        state.overridingClubId = 0;
      }
    },
  },

  actions: {
    populateAdditionalBookers(context, homeClubId) {
      services.ecom.listCategories(homeClubId, 661).then((data) => {
        context.commit('setAdditionalBookers', data.Items);
      }).catch(() => {
        context.commit('setAdditionalBookers', []);
      });
    },
  },
};

export { clubStore };
